module.exports = __webpack_public_path__ + "media/images/image_catchphrase-9e2ce745d160752fc8e78e8b37a8fb23.jpg";